<template>
    <tag-select
        class="forum-tag-select"
        :search="search"
        :canCreate="canCreate"
        :value="value"
        @input="$emit('input', $event)">
    </tag-select>
</template>

<script>
    // ForumTagSelect: stylizes the tag select input for the forum.

    import TagSelect from '../tag-select';

    export default {
        // See src/components/reusable/tag-select/index.vue for prop details.
        props: ['search', 'canCreate', 'value'],

        components: {
            TagSelect,
        },
    }
</script>

<style lang="scss" scoped>
    .forum-tag-select.tag-select {
        margin-top: 5px;
        background: #1e1e1e;
        border: 1px solid #484848;
    }
</style>

<style lang="scss">
    .forum-tag-select.tag-select {
        .v-select {
            border-bottom: none;
            padding: 0;
            height: 100%;
        }

        .dropdown-toggle {
            height: 100%;
            padding: 3px 33px 3px 5px;
            line-height: 26px;
        }

        input[type="search"] { // Specificity needed
            padding: 0;
            height: auto;
            line-height: inherit;
            top: 0;
        }

        .open-indicator {
            right: 12px;
            top: 8px;
            bottom: unset;
        }

        .selected-tag {
            margin: 2px;
            padding: 1px 6px;
            height: auto;
            vertical-align: middle;
        }

        .dropdown-menu {
            background: #1e1e1e;
            border-radius: 0;
            border-color: #484848;

            ul {
                background: inherit;
            }

            li {
                background: inherit;
                color: #ebebeb;
                height: 28px;
                line-height: 28px;
                padding: 0 10px;
                position: relative;

                &.no-options {
                    color: #b0b0b0;
                }

                a {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    padding: inherit;
                    line-height: inherit;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// tag-select.vue?4a3d01a8